import { Injectable } from '@angular/core';
import { AlertController, AlertInput } from '@ionic/angular';
import { AlertConfig } from '../models/notification/alert-config-interface';
import { DateTimeHelper } from '../utils/date-time-helper';

@Injectable()
export class AlertNotificationService {
  constructor(private alertController: AlertController) {}

  async show(config: AlertConfig) {
    const { suppression } = config;

    if (suppression) {
      const { suppressKey, suppressDuration } = suppression;
      const dateSuppressed = localStorage.getItem(suppressKey);
      const currentDateTime = DateTimeHelper.getUtcNowString();
      
      if (dateSuppressed) {
        if (!suppressDuration) {
          return;
        }
        else {
          const isWithinSupressionDuration = DateTimeHelper.checkTimeDifferenceLessThan('hours', suppressDuration, dateSuppressed, 'UTC', currentDateTime, 'UTC');
          if (isWithinSupressionDuration) {
            return;
          }
        }
      }

      const suppressCheckbox: AlertInput = {
        type: 'checkbox',
        name: 'suppress',
        label: suppression.suppressLabel || "Don't show again",
        handler: (val: AlertInput) => {
          const checked = val.checked;
          if (checked) {
            localStorage.setItem(suppressKey, currentDateTime);
          } else {
            localStorage.removeItem(suppressKey);
          }
        },
      };

      return await this.createAlert({ ...config, inputs: [suppressCheckbox] });
    } else {
      return await this.createAlert(config);
    }
  }

  private async createAlert(config: AlertConfig) {
    const alert = await this.alertController.create(config);
    await alert.present();

    return alert;
  }
}
